import { Box, useTheme } from '@mui/material';
import { EffectCoverflow, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import { ExperienceModel } from '@/logic/services/experiences';
import { FC } from 'react';
import { pxToRem } from '@/theme/typography';
import ImageBoxFuture from '../shared/image-box-future';

interface ExperienceImagesSliderProps {
  experience: ExperienceModel;
}
export const ExperienceImagesSlider: FC<ExperienceImagesSliderProps> = ({
  experience,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        '.swiper': {
          width: { mobile: '175%', tablet: '125%' },
          transform: {
            mobile: 'translateX(-20%)',
            tablet: 'translateX(-10%)',
          },
        },
        '& .swiper-slide': {
          paddingBottom: '40px',
        },
        '& .swiper-pagination-bullet': {
          width: { tablet: pxToRem(12), mobile: '6px' },
          height: { tablet: pxToRem(12), mobile: '6px' },
          background: theme.palette.grey[10],
          backdropFilter: 'blur(5px)',
          opacity: 1,
        },
        '& .swiper-pagination-bullet-active': {
          background: theme.palette.primary.main,
          border: `1px solid ${theme.palette.primary.main}`,
          width: { tablet: pxToRem(14), mobile: '8px' },
          height: { tablet: pxToRem(14), mobile: '8px' },
        },
      }}
    >
      <Swiper
        speed={600}
        loop
        slidesPerView={3}
        centeredSlides
        slideToClickedSlide
        pagination={{ clickable: true }}
        modules={[EffectCoverflow, Pagination]}
        effect='coverflow'
        coverflowEffect={{
          depth: 0,
          rotate: 0,
          scale: 0.8,
          slideShadows: false,
        }}
      >
        {experience?.imagesList?.map(image => (
          <SwiperSlide key={image}>
            <ImageBoxFuture
              img={image}
              title={experience?.name}
              layout='intrinsic'
              objectFit='cover'
              width='1920px'
              height='1080px'
              sx={{
                borderRadius: pxToRem(20),
                overflow: 'hidden',
                cursor: {
                  laptop: 'pointer',
                },
              }}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
};
